import { jobStatuses } from 'Constants/jobStatuses'
import _ from 'lodash'

export const isBookedPage = job =>
  _.get(job, 'jobStatus') === jobStatuses.booked ||
  _.get(job, 'jobStatus') === jobStatuses.completed ||
  _.get(job, 'jobStatus') === jobStatuses.done
